import { useEffect, useRef } from 'react';
interface Props {
  onOverThreshold: () => void;
  onUnderThreshold?: () => void;
  heightLimit?: number;
}

/**
 * @description 방송섬네일 밑의 방송제목이 2줄, 3줄로 넘어갔을 시 ...처리와 툴팁을 띄우기 위한 훅
 */
function useBroadcastDescriptionResizeHandler({
  onOverThreshold,
  onUnderThreshold,
  heightLimit = 60
}: Props) {
  const observerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const box_observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      for (const entry of entries) {
        const hasOverflow = entry.target.children[2].getBoundingClientRect().height > heightLimit;
        if (hasOverflow) {
          onOverThreshold?.();
        } else {
          onUnderThreshold?.();
        }
      }
    });
    if (observerRef.current) {
      box_observer.observe(observerRef.current);
    }
    return () => {
      box_observer.disconnect();
    };
  }, [observerRef.current, onOverThreshold, onUnderThreshold]);
  return {
    observerRef
  };
}
export default useBroadcastDescriptionResizeHandler;